import axios from 'axios';
import { API_URL } from '../config';
const base = `${API_URL}/transport-simulation`;

export async function importSimulationTransports(file) {
  const data = new FormData();
  data.append('file', file);
  return (await axios.post(`${base}/imports`, data, { withCredentials: true }))
    .data;
}
export async function rerunTransportSimulation(id) {
  return (
    await axios.post(
      `${base}/imports/${encodeURIComponent(id)}/simulate`,
      {},
      { withCredentials: true },
    )
  ).data;
}
export async function getTransportSimulation(id, params) {
  return (
    await axios.get(`${base}/runs/${id ? encodeURIComponent(id) : 'latest'}`, {
      params,
      withCredentials: true,
    })
  ).data;
}
export async function getTransportSimulationHistory(params) {
  return (await axios.get(`${base}/runs`, { params, withCredentials: true }))
    .data;
}

export async function retrySimulationNotification(id) {
  return (
    await axios.post(
      `${base}/runs/${encodeURIComponent(id)}/notification/retry`,
      {},
      { withCredentials: true },
    )
  ).data;
}

export async function getSimulationSettings() {
  return (await axios.get(`${base}/settings`, { withCredentials: true })).data;
}
export async function saveSimulationSettings(settings) {
  return (
    await axios.put(`${base}/settings`, settings, { withCredentials: true })
  ).data;
}
export async function previewSimulationScope(settings) {
  return (
    await axios.post(`${base}/scope-preview`, settings, {
      withCredentials: true,
    })
  ).data;
}
export async function previewTransportSimulation(id, settings) {
  return (
    await axios.post(
      `${base}/imports/${encodeURIComponent(id)}/preview`,
      settings,
      { withCredentials: true },
    )
  ).data;
}
export async function confirmSimulationArea(settings) {
  return (
    await axios.put(`${base}/area-confirmation`, settings, {
      withCredentials: true,
    })
  ).data;
}

export async function acceptSimulationShelfLife(data) {
  return (
    await axios.post(`${base}/shelf-life-acceptances`, data, {
      withCredentials: true,
    })
  ).data;
}
export async function revokeSimulationShelfLife(id, runId) {
  return (
    await axios.post(
      `${base}/shelf-life-acceptances/${encodeURIComponent(id)}/revoke`,
      { runId },
      { withCredentials: true },
    )
  ).data;
}
